<template>
    <div
        :class="[
            'ppv2-relative ppv2-border ppv2-rounded-lg ppv2-p-4 ppv2-shadow-sm ppv2-cursor-pointer hover:ppv2-border-primary-500 ppv2-transition-all',
            selected
                ? 'bg-purple ppv2-bg-opacity-[4%] border-purple ppv2-border-opacity-[35%]'
                : 'ppv2-bg-white ppv2-border-gray-200',
        ]"
        @click="$emit('toggle')"
    >
        <!-- Header: Title / logo / required asterisk on left, round checkbox on right -->
        <div class="ppv2-flex ppv2-justify-between ppv2-items-center">
            <div class="ppv2-flex ppv2-items-center">
                <img v-if="imageSrc" :src="imageSrc" class="ppv2-w-14 ppv2-mr-2" />
                <span :class="['poppinsSemiBold ppv2-text-black', titleSizeClass]">{{ title }}</span>
                <span v-if="required" class="poppinsSemiBold ppv2-text-base text-purple ppv2-ml-1">*</span>
            </div>

            <!-- Round checkbox aligned with title -->
            <div
                :class="[
                    'ppv2-rounded-full ppv2-border-2 ppv2-transition-all ppv2-ease-in-out ppv2-relative ppv2-flex-shrink-0 ppv2-flex ppv2-items-center ppv2-justify-center',
                    'ppv2-w-[29px] ppv2-h-[29px]',
                    selected
                        ? 'bg-purple ppv2-border-transparent !ppv2-bg-opacity-100'
                        : 'ppv2-bg-white ppv2-border-black ppv2-border-opacity-40',
                ]"
            >
                <svg v-if="selected" class="ppv2-w-4 ppv2-h-4 ppv2-text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                    />
                </svg>
            </div>
        </div>

        <!-- Body Content -->
        <div class="ppv2-mt-1">
            <div class="ppv2-flex ppv2-items-center ppv2-space-x-2">
                <div class="poppinsRegular ppv2-text-sm ppv2-text-black ppv2-text-opacity-60">
                    {{ description }}
                </div>
            </div>

            <div
                v-if="compactImageSrc"
                class="ppv2-bg-gray-50 ppv2-rounded-lg ppv2-p-3 ppv2-pl-7 ppv2-mt-3 ppv2-inline-flex ppv2-items-center"
            >
                <img :src="compactImageSrc" class="ppv2-h-8 ppv2-object-contain" />
            </div>

            <div
                v-else-if="imagesSrc.length && compactImages"
                class="ppv2-bg-gray-50 ppv2-rounded-lg ppv2-p-3 ppv2-mt-3 ppv2-inline-flex ppv2-items-center ppv2-gap-2 ppv2-flex-wrap"
            >
                <div v-for="(img, index) in imagesSrc" :key="index">
                    <img :src="img" class="ppv2-object-contain" />
                </div>
            </div>

            <div v-else-if="imagesSrc.length" class="ppv2-grid ppv2-grid-cols-3 ppv2-gap-5 ppv2-mt-3">
                <div v-for="(img, index) in imagesSrc" :key="index" class="ppv2-border ppv2-rounded-lg ppv2-p-8 ppv2-shadow-sm">
                    <img :src="img" class="ppv2-w-full ppv2-h-12 ppv2-object-contain" />
                </div>
            </div>

            <InfoMessageBox v-if="optionalMessage" class="ppv2-mt-2" :message="optionalMessage" color="info" />

            <div v-if="$slots.default" @click.stop>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import InfoMessageBox from './InfoMessageBox.vue'

export default {
    name: 'SelectableCard',
    components: { InfoMessageBox },
    props: {
        selected: Boolean,
        title: { type: String, required: true },
        description: { type: String, default: '' },
        required: { type: Boolean, default: false },
        optionalMessage: { type: String, default: '' },
        imageSrc: { type: String, default: '' },
        imagesSrc: { type: Array, default: () => [] },
        compactImageSrc: { type: String, default: '' },
        compactImages: { type: Boolean, default: false },
        sizeClass: { type: String, default: 'ppv2-w-[29px] ppv2-h-[29px]' },
        titleSizeClass: { type: String, default: 'ppv2-text-md' },
    },
}
</script>
